'use client';

import { Box, Skeleton } from '@mui/material';

import { ButtonSkeleton } from './common/ButtonSkeleton';

export const HeaderActionsSkeleton = () => {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 } }}>
      <ButtonSkeleton width={100} sx={{ display: { xs: 'none', sm: 'block' } }} />

      <ButtonSkeleton width={80} />
      <Skeleton
        variant="circular"
        width={32}
        height={32}
        sx={{ display: { xs: 'none', md: 'block' }, ml: 1 }}
      />
    </Box>
  );
};
